import React from "react";
import { Login_Form } from "../../AtomStore/store";
import manifest from "../../manifest.json";

import background from "../../assets/bg-pattern.jpg";
import logo from "../../assets/splash-nico-hi.png";
import { useAtom } from "jotai";
import { useRequestProcessor } from "../../requestProcessor";
import { handleLogin } from "../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import MobileBlogs from "../Blogs/Blogs";

const LoginMobile = () => {
  const { useMutationWrapper } = useRequestProcessor();
  const [form, setForm] = useAtom(Login_Form);

  const Login = useMutationWrapper("Login", () => handleLogin(form, setForm));

  const keyPressed = (event) => {
    if (event.key === "Enter") {
      const form = event.target.form;
      const index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1].focus();
    }
  };

  const validate = () => {
    if (form.phone === "" && form.email === "") {
      setForm({ ...form, error: "Please Enter Phone number or Email Id" });
      return false;
    } else if (
      form.phone &&
      (!form.phone.match(/^[0-9]+$/) || form.phone.length !== 10)
    ) {
      setForm({ ...form, error: "Please Enter valid number" });
      return false;
    } else {
      return true;
    }
  };
  const login = () => {
    setForm({ ...form, error: "" });
    Login.mutate();
  };
  return (
    <>
      <div
        className="h-dvh overflow-y-auto bg-cover bg-center pb-2 px-2 md:hidden"
        style={{ backgroundImage: `url("${background}")` }}
      >
        {Login.isLoading ? <SpinnerLoading /> : <></>}

        <img
          src={logo}
          className="w-70 relative top-[60px] left-0"
          style={{ right: "calc(-30vw)" }}
          alt="bird"
        ></img>
        <div className="w-full  bg-white px-3 py-5 rounded-br-3xl rounded-tl-3xl">
          <h3 className="text-dark font-bold text-2xl">Login</h3>
          {/* <p className="mt-2 font-normal leading-5">
          Enter email and phone number <br /> to send one time password
        </p> */}
          <h3 className="mt-3 font-semibold">Phone Number</h3>
          <input
            className="w-full rounded-full border-2 h-12 mt-2 px-3"
            type="number"
            name="phone"
            placeholder="Your phone number"
            value={form.phone}
            onChange={(e) =>
              setForm({ ...form, phone: e.target.value, email: "", error: "" })
            }
            onKeyPress={keyPressed}
          ></input>
          <h3 className="mt-3 font-semibold text-center">OR</h3>

          <h3 className="mt-3 font-semibold">Email Address</h3>
          <input
            className="w-full rounded-full border-2 h-12 mt-2 px-3"
            type="email"
            name="email"
            placeholder="Your email address"
            value={form.phone ? "" : form.email}
            onChange={(e) =>
              setForm({ ...form, email: e.target.value, phone: "", error: "" })
            }
            onKeyPress={keyPressed}
          ></input>
          {typeof form.error !== "undefined" && (
            <p className="text-red leading-5 px-2 mt-">{form.error}</p>
          )}
          <button
            className="w-full rounded-full  h-16 bg-[#47aee4] text-white text-lg font-bold mt-10"
            onClick={() => {
              if (validate()) {
                login();
              }
            }}
            size="lg"
            block
          >
            {" "}
            Login
          </button>
          <h3 className="text-center mt-1 font-semibold">{`${manifest.applicationName} v${manifest.version}`}</h3>
        </div>
      </div>

      <div className="hidden md:flex justify-center gap-3 mt-20 rounded-2xl overflow-visible">
        <div className="w-[60vw]">
          {/* <h1
            className="h-20 w-full text-white flex justify-center items-center text-3xl mb-2"
            style={{
              backgroundColor: "rgb(71 174 228 / var(--tw-bg-opacity, 1))",
            }}
          >
            Blogs
          </h1> */}
          <MobileBlogs />
        </div>

        {/* Sticky Login Section */}
        <div className="sticky top-10 h-[100vh] [@media(max-width:1000px)]:relative">
          <div
            className="bg-cover bg-center pb-2 px-2 w-[30vw] md:block "
            style={{ backgroundImage: `url("${background}")` }}
          >
            {Login.isLoading ? <SpinnerLoading /> : <></>}

            <img
              src={logo}
              className="w-45 relative top-[60px] left-0"
              style={{ right: "calc(-30vw)" }}
              alt="bird"
            ></img>

            <div className="w-full bg-white px-3 py-5 rounded-br-3xl rounded-tl-3xl">
              <h3 className="text-dark font-bold text-2xl">Login</h3>

              <h3 className="mt-3 font-semibold">Phone Number</h3>
              <input
                className="w-full rounded-full border-2 h-12 mt-2 px-3"
                type="number"
                name="phone"
                placeholder="Your phone number"
                value={form.phone}
                onChange={(e) =>
                  setForm({
                    ...form,
                    phone: e.target.value,
                    email: "",
                    error: "",
                  })
                }
                onKeyPress={keyPressed}
              ></input>

              <h3 className="mt-3 font-semibold text-center">OR</h3>

              <h3 className="mt-3 font-semibold">Email Address</h3>
              <input
                className="w-full rounded-full border-2 h-12 mt-2 px-3"
                type="email"
                name="email"
                placeholder="Your email address"
                value={form.phone ? "" : form.email}
                onChange={(e) =>
                  setForm({
                    ...form,
                    email: e.target.value,
                    phone: "",
                    error: "",
                  })
                }
                onKeyPress={keyPressed}
              ></input>

              {typeof form.error !== "undefined" && (
                <p className="text-red leading-5 px-2 mt-">{form.error}</p>
              )}

              <button
                className="w-full rounded-full h-16 bg-[#47aee4] text-white text-lg font-bold mt-10"
                onClick={() => {
                  if (validate()) {
                    login();
                  }
                }}
                size="lg"
                block
              >
                Login
              </button>
              <h3 className="text-center mt-1 font-semibold">
                {`${manifest.applicationName} v${manifest.version}`}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginMobile;
